import { useEffect, useState } from 'react'

export const useDebounce = <T,>(value: T, delay = 250) => {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(t)
  }, [value, delay])
  return debounced
}
